import { render, staticRenderFns } from "./SorceManagement.vue?vue&type=template&id=2da43d4a&scoped=true"
import script from "./SorceManagement.vue?vue&type=script&lang=js"
export * from "./SorceManagement.vue?vue&type=script&lang=js"
import style0 from "./SorceManagement.vue?vue&type=style&index=0&id=2da43d4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da43d4a",
  null
  
)

export default component.exports